module.exports = __webpack_public_path__ + "img/qyjy2-2.32e38621.png";